import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingModal from '@ublique/components/Modal'
import DataTable from '@ublique/components/DataTable'
import TableActions from '@ublique/components/DataTable/components/TableActions'
import { useAgGridTranslation } from 'utils/hooks/useDocumentTranslation'
import Tabs from '@ublique/components/Tabs'
import Tab from '@ublique/components/Tabs/Tab'

import './index.scss'
import {
  filtering,
  pagination,
  styling,
  defaultColumnDefs,
  getTablecActions,
  getColumnDefs
} from './table'
import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'
// import body from './mock.json'
import { keys } from 'lodash'

function ProgressScenarioModal({ open, close, data }) {
  const [gridApi, setGridApi] = useState()
  const [tableData, setTableData] = useState()
  const [noStandardColumns, setNoStandardColumns] = useState([])
  const { t } = useTranslation(['Scenario', 'Document', 'Shell'])
  const { t: agGridT } = useAgGridTranslation()
  const { scenario, component } = data
  const { id } = scenario

  const fetchScenarioProgressData = async function (hideOverlay = false) {
    const url = `${BASE_URL}/scenarioflow/progress/${id}`
    // const url = `${BASE_URL}/scenarios`
    const response = await synapse.fetch(url)
    const { body } = response

    const additionalColumns = []

    const progressData = body.map((row) => {
      additionalColumns.push(...keys(row.customPropsList))
      return { ...row, ...row.customPropsList }
    })

    setNoStandardColumns([...new Set(additionalColumns)])
    setTableData(progressData)

    if (hideOverlay) {
      gridApi.api.hideOverlay()
    }
  }

  useEffect(() => {
    // only without an external component
    fetchScenarioProgressData()
  }, [])

  const refreshButtonAction = () => {
    gridApi.api.showLoadingOverlay()
    fetchScenarioProgressData(true)
  }
  const exportCsvButtonAction = () => {
    gridApi.api.exportDataAsCsv({
      fileName: `${t('Scenario.ScenarioProgress.PROGRESS_MODAL_TITLE')}.csv`
    })
  }

  const renderTable = () => {
    return (
      <DataTable
        onGridReady={(params) => setGridApi(params)}
        {...filtering}
        {...styling}
        {...pagination}
        columnDefs={getColumnDefs(t, noStandardColumns)}
        defaultColDef={defaultColumnDefs}
        rowData={tableData}
        className='trend-scenario-table'
        extraHeaderComponent={
          <TableActions
            t={agGridT}
            config={getTablecActions({
              t,
              refreshButtonAction,
              exportCsvButtonAction
            })}
          />
        }
      />
    )
  }

  const renderModalBody = () => {
    if (!component) {
      return <div className='table-progress'>{renderTable()}</div>
    }

    return (
      <Tabs className='trend-tabs'>
        <Tab
          className='trend-tab'
          title={t('Scenario.ScenarioProgress.Tab.Table')}
          key='tab1'
        >
          {renderTable()}
        </Tab>
        <Tab
          className='trend-tab'
          title={t('Scenario.ScenarioProgress.Tab.Details')}
          key='tab2'
        >
          {component()}
        </Tab>
      </Tabs>
    )
  }

  return (
    <LoadingModal
      loading
      passiveModal
      size='lg'
      className='trend-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t('Scenario.ScenarioProgress.PROGRESS_MODAL_TITLE')}
    >
      <div className='table-class'>{renderModalBody()}</div>
    </LoadingModal>
  )
}

export default ProgressScenarioModal
